import { getSessionStorage, setSessionStorage } from '@utils/states/sessionStorage'
import { shouldShowBudgetPopup } from './helpers/shouldShowBudgetPopup'
import { useBudgetValidation } from '.'

import * as apiBudget from '@services/api/budget'

const checkBudgetValidation = async () => {
  const { setBudgetInfo, setShouldShowPopup } = useBudgetValidation.getState()

  try {
    const budgetInfo = await apiBudget.getBudgetValidationStatus()
    const alreadySeenThisSession = !!getSessionStorage<boolean>('@SMARTOPS_BUDGET_POPUP_SEEN')

    setBudgetInfo(budgetInfo)
    // RISCO A CONFIRMAR COM O BACKEND: `exibirPopup` precisa refletir "ainda não confirmado
    // NESTA sessão/login" (RC03/CA04 exigem reaparecer em novo login enquanto o budget não for
    // validado). A trava local por sessionStorage abaixo garante isso do lado do front mesmo que
    // `visualizado` persista de forma permanente no backend.
    setShouldShowPopup(shouldShowBudgetPopup(budgetInfo.exibirPopup, alreadySeenThisSession))
  } catch {
    // Falha ao consultar o status de validação não pode travar o login — apenas não exibe o popup.
    setShouldShowPopup(false)
  }
}

const confirmPopup = () => {
  const { setShouldShowPopup } = useBudgetValidation.getState()

  setSessionStorage('@SMARTOPS_BUDGET_POPUP_SEEN', true)
  setShouldShowPopup(false)

  apiBudget.ackBudgetValidationPopup().catch(() => {})
}

export { checkBudgetValidation, confirmPopup }
